import FileModel from '../../../../../models/FileModel'
import modal from '../../../../../sections/modal'
import { parseFile } from '../../../../../utilities/fileTools'
import { get } from '../../../../../utilities/http'
import {
    formDutyISCIVA,
    reqLDCostDistribution,
    reqLogisticalCost1,
    reqLogisticalCost2,
    tableDutyControl
} from '../storageStep2'
import Cost from '../cost'
import { loadForm } from './utilities'
import { FormDuty } from '.'

export default function useSubmitDuty(logistical_cost_id: number) {
    const { submit, validation, observer } = formDutyISCIVA.useSubmit(
        `/v5.6/apis/logistical_costs/duty/${logistical_cost_id}`,
        {
            done: () => {
                reqLogisticalCost1.load()
                reqLogisticalCost2.load()
            },
            method: 'put'
        }
    )

    let currentFiles: FileModel[] = []

    validation(() => {
        return tableDutyControl.test(f => {
            f.percentage.isEmpty('Se requiere ingresar el arancel')
        })
    })

    observer<Cost.PutBodyModalDuty>(f => ({
        agent_id: f.agent && parseInt(f.agent.value),
        document_number: f.document_number,
        setting_local_cost: Number(f.setting_local_cost),
        reception_ids: f.rcs.map(option => parseInt(option.value)),
        original_cost_products: tableDutyControl.getDataList().map(ocp => ({
            product_id: ocp.product_id,
            percentage: Number(ocp.percentage) / 100
        })),
        new_files: f.files
            .filter(file => !file.id)
            .map(file => parseFile(file)),
        files_to_delete: currentFiles
            .filter(cf => !f.files.find(file => file.id === cf.id))
            .map(cf => cf.id)
    }))

    return function handleModal() {
        modal(
            FormDuty,
            async () => {
                const res = await get<Cost.ResponseLCDuty>(
                    `/v5.6/apis/logistical_costs/duty/${logistical_cost_id}`
                )

                currentFiles = res.data.result.files

                loadForm(res.data.result)

                reqLDCostDistribution.setParam(
                    'logistical_declaration_id',
                    res.data.result.logistical_declaration_id
                )

                return {
                    title: 'Aranceles (Por producto)',
                    onSubmit: submit,
                    props: res.data.result
                }
            },
            'md'
        )
    }
}
